// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Atemption_wrapper__Di1Bz","content":"Atemption_content__39xOe"};